const templateText = require('shared/messages/templateText'),
    basicText = require('shared/messages/basicText'),
    rawText = require('shared/messages/rawText');

// This module serves as the main hub for messaging and translating.
// Output messages, particularly those that are repeated, should be contained in
// one of the above required modules.
// Additionally, messages or text that requires translation is served through
// this module, by functions contained in the above required modules.

module.exports = _.extend(templateText, basicText, rawText);
